export const adaptFrecuenciaModoDespacho = (frecuenciaModoDespachoData) => {
    return {
        id: frecuenciaModoDespachoData?.idFrecuenciaModoDespacho,
        displayName: frecuenciaModoDespachoData?.descripcion,
        name: frecuenciaModoDespachoData?.descripcion
    }
}

export const adaptFrecuenciaModoDespachoArray = (
    frecuenciasModoDespacho
) => {
    return structuredClone(frecuenciasModoDespacho?.allFrecuenciaModoDespacho)
        ?.map(frecuenciaModoDespacho => adaptFrecuenciaModoDespacho(frecuenciaModoDespacho));
}